import { isNotDefined } from '@sgme/fp';
import { Select } from '@sgme/ui';
import { useSgwtWidgets } from '@sgwt/sgwt-widgets-react';
import { FormattedMessage, useIntl } from 'react-intl';

import { OptionFormGroup } from '@/App/tiles/Option/fields/OptionFormGroup.tsx';
import { useOptionSelector } from '@/App/tiles/Option/OptionContext.ts';
import { useCheckOption } from '@/App/tiles/Option/QueueContext.tsx';

type TriggerTypeProps = {
  tileId: string;
};

export function TriggerType({ tileId }: TriggerTypeProps) {
  const { sgwtWebAnalytics } = useSgwtWidgets();
  const { formatMessage } = useIntl();
  const [checkOption] = useCheckOption();
  const { barrier1, barrier2 } = useOptionSelector((option) => {
    const leg = option.properties.legs[0];
    return {
      barrier1: leg?.barrier1,
      barrier2: leg?.barrier2,
    };
  });

  function handleTriggerTypeChange(triggerType: 1 | 2) {
    sgwtWebAnalytics?.trackEvent('Option', 'trigger type changed', String(triggerType));

    checkOption({
      tileId,
      legProperties: {
        legId: `${tileId}/0`,
        ...(triggerType === 1 ? { barrier1: {}, barrier2: null } : { barrier2: {} }),
      },
    });
  }

  if (isNotDefined(barrier1) && isNotDefined(barrier2)) {
    return null;
  }
  const selectedItemValue = isNotDefined(barrier2) ? 1 : 2;

  return (
    <OptionFormGroup label={<FormattedMessage id="option.fields.triggerType" />}>
      <div className="d-flex flex-grow-1 gap-1">
        <Select
          data-e2e="trigger-type-select"
          className="form-select form-select-sm"
          selectedItemValue={String(selectedItemValue)}
          itemToString={(item) => formatMessage({ id: `option.fields.triggerType.${item}` })}
          itemsAsObjects={[1, 2]}
          onChange={handleTriggerTypeChange}
        />
      </div>
    </OptionFormGroup>
  );
}
